(() => {
  // Obrazy startuja bez `src` (tylko data-card-src) i doczytuja sie dopiero przy
  // wejsciu w viewport. Natywne loading="lazy" nie wystarczalo: Chrome sciagal
  // kafel redakcyjny ~280 ms po starcie, mimo ze lezy ~1500 px ponizej folda,
  // i zabieral 104 kB pasma obrazowi LCP.
  const PRIMARY = '.neckle-product-card__image-primary[data-card-src], .neckle-home-editorial__image--primary[data-card-src]';
  const SECONDARY = '.neckle-product-card__image-secondary[data-card-src], .neckle-home-editorial__image--secondary[data-card-src]';
  const HOVER_CONTAINER = '.neckle-product-card__image, .neckle-home-editorial__link';

  const loadPrimaryImage = (image) => {
    if (!image || image.dataset.cardPrimaryLoading) return;
    image.dataset.cardPrimaryLoading = 'true';
    if (image.dataset.cardSrcset) image.srcset = image.dataset.cardSrcset;
    image.src = image.dataset.cardSrc;
  };

  const loadSecondaryImage = (card) => {
    const image = card?.querySelector(SECONDARY);
    if (!image || image.dataset.cardSecondaryLoading) return;
    image.dataset.cardSecondaryLoading = 'true';

    const reveal = () => image.setAttribute('data-card-secondary-ready', '');
    image.addEventListener('load', reveal, { once: true });
    if (image.dataset.cardSrcset) image.srcset = image.dataset.cardSrcset;
    image.src = image.dataset.cardSrc;
    if (image.complete) reveal();
  };

  const primaryImages = document.querySelectorAll(PRIMARY);
  if ('IntersectionObserver' in window) {
    const primaryObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadPrimaryImage(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    primaryImages.forEach((image) => primaryObserver.observe(image));
  } else {
    primaryImages.forEach(loadPrimaryImage);
  }

  // Obraz hover doczytuje sie dopiero przy realnym najechaniu kursorem, wiec na
  // dotyku - gdzie reguly :hover i tak nigdy nie zadzialaja - nie leci wcale.
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const card = event.target.closest?.(HOVER_CONTAINER);
    if (!card) return;
    loadPrimaryImage(card.querySelector(PRIMARY));
    loadSecondaryImage(card);
  }, { passive: true });
  document.addEventListener('focusin', (event) => {
    const card = event.target.closest?.(HOVER_CONTAINER);
    if (!card) return;
    loadPrimaryImage(card.querySelector(PRIMARY));
    loadSecondaryImage(card);
  });
})();
